module.exports = __webpack_public_path__ + "img/txp5.fbaa24fb.jpg";